import React from "react";
import { Stack, Typography } from "@mui/material";

import { PagePrint } from "../../components";
import { useGetEmployeeList } from "../../hooks";

// Helper function to chunk the array into subarrays of the specified size
const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

const columns = 3;
const rows = 3;

const EmployeeCard = ({ name, id }) => {
  return (
    <Stack
      sx={{
        "*": { textAlign: "center", lineHeight: 1 },
        height: `calc((8.5in - (${rows - 1} * 5px ) - 48px) / ${rows})`,
        border: "0.25px solid",
        borderColor: "hubColors.black",
        boxSizing: "border-box",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Typography variant="boldCaption" fontSize="24px">
        {name}
      </Typography>
      <Typography variant="caption" fontSize="18px">
        {id}
      </Typography>
      <Typography variant="barcode" fontSize="65px" lineHeight="65px">
        *{id}*
      </Typography>
    </Stack>
  );
};

export const EmployeeSheet = ({ defaultLocation = 1 }) => {
  const { data, isError } = useGetEmployeeList({
    location: defaultLocation,
    enabled: true,
  });

  if (isError) return <></>;

  const filtered = data?.filter((e) => e?.employeeId?.length >= 6);
  const employees =
    chunkArray(filtered || [], rows * columns)?.filter(
      (chunk) => chunk?.length
    ) || [];

  return (
    <Stack
      display="none"
      sx={{
        overflowX: "hidden",
        overflowY: "auto",
        "*::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <Stack gap="10px" className="print-only">
        {employees.map((chunk, index) => (
          <PagePrint
            key={`page-${index}`}
            id={`page-${index}`}
            stackProps={{
              sx: {
                padding: "0px",
                gap: "2px",
                display: "grid",
                gridTemplateColumns: `repeat(${columns}, 33%)`,
                gridTemplateRows: `repeat(${rows}, 1fr)`,
                overflow: "hidden",
              },
            }}
            flip
          >
            {chunk.map((e, i) => (
              <EmployeeCard
                key={`${index}-${i}`}
                name={e.name}
                id={e.employeeId}
              />
            ))}
          </PagePrint>
        ))}
      </Stack>
    </Stack>
  );
};

export default EmployeeSheet;
